"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var login_actions_1 = require("../actions/login.actions");
/*type dispatch =
    typeof userActions.login // ... plus action creators we've requested
    & RouteComponentProps<{}>; // ... plus incoming routing parameters*/
var LoginForm = /** @class */ (function (_super) {
    __extends(LoginForm, _super);
    function LoginForm(props) {
        var _this = _super.call(this, props) || this;
        props.dispatch(login_actions_1.userActions.logout());
        _this.state = {
            email: '',
            password: '',
            submitted: false,
            loggingIn: false,
        };
        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        return _this;
    }
    LoginForm.prototype.handleChange = function (e) {
        var _a;
        var _b = e.target, name = _b.name, value = _b.value;
        this.setState((_a = {}, _a[name] = value, _a));
    };
    LoginForm.prototype.handleSubmit = function (e) {
        e.preventDefault();
        this.setState({ submitted: true });
        var _a = this.state, email = _a.email, password = _a.password;
        var dispatch = this.props.dispatch;
        if (email && password) {
            dispatch(login_actions_1.userActions.login(email, password));
        }
    };
    LoginForm.prototype.render = function () {
        var loggingIn = this.props.loggingIn;
        var _a = this.state, email = _a.email, password = _a.password, submitted = _a.submitted;
        var loggedIn = loggingIn === undefined ? true : loggingIn;
        return (React.createElement("div", { className: "col-md-6 col-md-offset-3" },
            React.createElement("h2", null, "Login"),
            React.createElement("br", null),
            " ",
            React.createElement("br", null),
            React.createElement("form", { name: "form", onSubmit: this.handleSubmit },
                React.createElement("div", { className: 'form-group' + (submitted && !email ? ' has-error' : '') },
                    React.createElement("label", { htmlFor: "username" }, "Email Address"),
                    React.createElement("input", { type: "text", className: "form-control", name: "email", value: email, onChange: this.handleChange }),
                    submitted && !email &&
                        React.createElement("div", { className: "alert alert-danger", role: "alert" },
                            React.createElement("strong", null, "Email Address is required"))),
                React.createElement("div", { className: 'form-group' + (submitted && !password ? ' has-error' : '') },
                    React.createElement("label", { htmlFor: "password" }, "Password"),
                    React.createElement("input", { type: "password", className: "form-control", name: "password", value: password, onChange: this.handleChange }),
                    submitted && !password &&
                        React.createElement("div", { className: "alert alert-danger", role: "alert" },
                            React.createElement("strong", null, "Password is required"))),
                React.createElement("div", { className: "form-group" },
                    React.createElement("button", { className: "btn btn-primary" }, "Login")),
                !loggedIn && (React.createElement("div", { className: "alert alert-danger", role: "alert" },
                    React.createElement("strong", null, "User is not authenticated"))))));
    };
    return LoginForm;
}(React.PureComponent));
exports.LoginForm = LoginForm;
function mapStateToProps(state) {
    var _a = state.authentication, loggingIn = _a.loggingIn, user = _a.user;
    return {
        loggingIn: loggingIn,
        user: user
    };
}
exports.default = react_redux_1.connect(mapStateToProps)(LoginForm);
//# sourceMappingURL=LoginForm.js.map